import React from "react";
import PanelGroupController from "../PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../panels/PropertiesList";

const AvailabilityPropertiesPanel = (props) => {

  let elements = null;
  if (!props.hasSelection) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "code", label: "Code", type: "string"},
      {prop: "region", label: "Region", type: "string"},
      {prop: "name", label: "Name", type: "string"},
      {prop: "availability", label: "Availability", type: "string"},
      {prop: "warehouse_id", label: "Warehouse", type: "string", help: "Designated warehouse to ship to this location"},
      {prop: "jurisdiction_id", label: "Jurisdiction", type: "string", help: "The company which has jurisdiction in this location"}
    ])
    elements = <PropertiesList properties={properties} data={props.selectedAvailability} />
  }

  return (
    <PanelGroupController title="Availability Properties" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default AvailabilityPropertiesPanel;